import { ConflictType } from '@editor2/types/conflict';
import { BookChildrenReorderConflictResolver } from './childrenReorderResolver';
import { BookPropertyConflictResolver } from './propertyResolver.';

export class BookResolver {
	getTypeResolver = (key: ConflictType) => {
		switch (key) {
			case ConflictType.Property: {
				const resolver = new BookPropertyConflictResolver();
				return resolver;
			}

			case ConflictType.ChildrenReorder: {
				const resolver = new BookChildrenReorderConflictResolver();
				return resolver;
			}

			default:
				break;
		}
	};
}
